import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Booking } from '../../models';

@Component({
    selector: 'app-booking-view-dialog',
    standalone: false,
    templateUrl: './booking-view-dialog.component.html',
    styleUrls: ['./booking-view-dialog.component.scss']
})
export class BookingViewDialogComponent implements OnInit {
    booking!: Booking;

    constructor(
        private dialogRef: DynamicDialogRef,
        private config: DynamicDialogConfig
    ) { }

    ngOnInit(): void {
        this.booking = this.config.data?.booking;
    }

    getStatusLabel(status: number | any): string {
        const options = [
            { label: 'Pending', value: 1 },
            { label: 'Confirmed', value: 2 },
            { label: 'Rejected', value: 3 },
            { label: 'Cancelled', value: 4 },
            { label: 'On Way', value: 5 },
            { label: 'Completed', value: 6 }
        ];
        const found = options.find(s => s.value === Number(status));
        return found ? found.label : 'Unknown';
    }

    getStatusSeverity(status: number | any): any {
        const val = Number(status);
        switch (val) {
            case 1: return 'info'; // Pending
            case 2: return 'success'; // Confirmed
            case 3: return 'danger'; // Rejected
            case 4: return 'danger'; // Cancelled
            case 5: return 'warn'; // On Way
            case 6: return 'success'; // Completed
            default: return 'info';
        }
    }

    getServiceNames(): string {
        const services = this.booking?.services?.length ? this.booking.services : [];

        if (!services.length) {
            return '-';
        }

        const names = services.map((service: any) => service.title || service.name).filter(Boolean);
        return names.length ? names.join(', ') : '-';
    }

    getBookingLocation(): string {
        const patientLocation: any = this.booking?.patient_location;
        const directCandidates = [
            this.booking?.location,
            patientLocation?.address,
            patientLocation?.address_line,
            patientLocation?.name,
            patientLocation?.details?.address_line,
            patientLocation?.details?.address,
            patientLocation?.details?.full_address
        ];

        const directMatch = directCandidates
            .map((value) => (typeof value === 'string' ? value.trim() : ''))
            .find((value) => value.length > 0);

        if (directMatch) {
            return directMatch;
        }

        const detailsParts = [
            patientLocation?.details?.building,
            patientLocation?.details?.area,
            patientLocation?.details?.city,
            patientLocation?.details?.emirate
        ]
            .map((value) => (typeof value === 'string' ? value.trim() : ''))
            .filter((value) => value.length > 0);

        return detailsParts.length ? detailsParts.join(', ') : '-';
    }

    close(): void {
        this.dialogRef.close();
    }
}
